import React from 'react';
import {createBrowserHistory, createPath} from '../../node_modules/react-router/dist/production/lib/router/history.js';
import {Router, Route, Routes} from '../../node_modules/react-router/dist/production/lib/components.js';
import {useNavigate} from '../../node_modules/react-router/dist/production/lib/hooks.js';

export {Route, Routes};
export {useLocation, useNavigate, useParams} from '../../node_modules/react-router/dist/production/lib/hooks.js';

const isModifiedEvent = (event) =>
  event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;

export function BrowserRouter({basename, children, useTransitions, window}) {
  const historyRef = React.useRef(null);

  if (historyRef.current == null) {
    historyRef.current = createBrowserHistory({window, v5Compat: true});
  }

  const history = historyRef.current;
  const [state, setStateImpl] = React.useState({
    action: history.action,
    location: history.location,
  });

  const setState = React.useCallback((newState) => {
    if (useTransitions === false) {
      setStateImpl(newState);
      return;
    }

    React.startTransition(() => setStateImpl(newState));
  }, [useTransitions]);

  React.useLayoutEffect(() => history.listen(setState), [history, setState]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={history}
      useTransitions={useTransitions}
    >
      {children}
    </Router>
  );
}

export const Link = React.forwardRef(function LinkWithRef(
  {onClick, reloadDocument, replace, state, target, to, ...rest},
  ref
) {
  const navigate = useNavigate();
  const href = typeof to === 'string' ? to : createPath(to);

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }

    if (
      !event.defaultPrevented &&
      !reloadDocument &&
      event.button === 0 &&
      (!target || target === '_self') &&
      !isModifiedEvent(event)
    ) {
      event.preventDefault();
      navigate(to, {replace, state});
    }
  };

  return (
    <a {...rest} href={href} onClick={handleClick} ref={ref} target={target} />
  );
});
